import { useNavigate, useParams } from "react-router-dom";
import { useAliasAvailable, useLinksActivate } from "./links-queries";
import styles from "./links.module.scss";
import { Field, Form, Formik, useField } from "formik";
import * as Yup from "yup";

export function LinksActivate() {
    const navigate = useNavigate();
    const { accountID, showID } = useParams();
    const activate = useLinksActivate(accountID, showID);
    const aliasAvailable = useAliasAvailable(accountID, showID);

    const validationSchema = Yup.object().shape({
        alias: Yup.string()
            .label("URL")
            .max(100)
            .required()
            .test("checkCombinedUrl", "Must be a vaild URL", alias =>
                Yup.string().url().isValid(`https://link.podtrac.com/${ alias }`)
            )
            .test(
                "checkAliasAvaliable",
                "URL already in use",
                aliasAvailable
            ),
    });

    return (
        <>
            <p>Set up a Smartlink for your show, use it anywhere online, then view results when people click on it and listen to your podcast.</p>

            <h2>1 - Choose a Custom Smartlink</h2>

            <p>Select your custom url by typing in the path you want to use for your link. You can use your show name or anything else that makes sense for your show.</p>
            <div className={styles.section}>
                <Formik
                    initialValues={{ alias: "" }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        activate
                            .mutateAsync(values)
                            .then((promotionID) => {
                                navigate(`settings/${ promotionID }`);
                            });
                    }}>
                    <Form>
                        <AliasField name="alias" />
                    </Form>
                </Formik>
            </div>

            <h2>2 - See the Custom Landing Page for Your Show</h2>
            <p>We give you a landing page for your Custom Smartlink that’s customized for your show, and optimized for mobile and desktop, Apple and Android.</p>

            <h2>3 - Post Your Smartlink</h2>
            <p>Post your Smartlink to social media, newsletters, emails, other websites, show or episode descriptions, anywhere online.</p>

            <h2>4 - View Results</h2>
            <p>Come back to this page to view results. Here are the metrics you will see on your reports page:</p>

            <div className={styles.section}>
            <dl className={styles.metrics}>
                <dt>Clicks</dt>
                <dd>Number of times the link has been clicked.</dd>
                <dt>Downloads</dt>
                <dd>Number of episodes of the promoted show downloaded by anyone who clicked the trackable link. (This includes new and existing listeners of the promoted show.)</dd>
                <dt>Download (Conversion) Rate</dt>
                <dd>Downloads / Clicks</dd>
                <dt>New Downloads</dt>
                <dd>Number of episodes of the promoted show downloaded by new listeners who clicked the trackable link.</dd>
                <dt>New Download (Conversion) Rate</dt>
                <dd>New Downloads / Clicks</dd>
            </dl>
            </div>

            <p>Note: For large podcasts and networks, Podtrac offers an Audio Promo + Smartlink service with additional features. To schedule a demo of this service, email support@podtrac.com.</p>
        </>
    );
}

function AliasField(props) {
    const [field, meta] = useField(props);
    return <>
        <label>
            <b>https://link.podtrac.com/</b>
            <input {...field} />
        </label>
        <button type="submit" style={{margin: "0 0.5rem"}}>
            Activate
        </button>
        {meta.touched && meta.error ? meta.error : null}
    </>;
}